var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.signInMethod').toUpperCase()) + "\n      ")]), _c('v-card-text', [_vm.method ? _c('div', {
    staticClass: "signin-instructions ma-0 pa-2"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v(_vm._s(_vm.method))]), _vm.link ? _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("Click here")]) : _vm._e()]) : _c('div', {
    staticClass: "signin-instructions ma-0 pa-2"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_c('i', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.noSignInMethod')))])])])]), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _vm.method ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirmSignInMethod();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.confirmSignInMethod')) + "\n          ")]) : _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirmSignInMethod();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }